export default __webpack_public_path__ + "static/media/logout.7d1c8983.svg";